export const Auth = {
  // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
  // identityPoolId: 'us-west-2:b687daa6-a346-4110-93df-a9cd1f227a57',

  // REQUIRED - Amazon Cognito Region
  region: 'us-east-1',

  // OPTIONAL - Amazon Cognito Federated Identity Pool Region
  // Required only if it's different from Amazon Cognito Region
  // identityPoolRegion: 'XX-XXXX-X',

  // OPTIONAL - Amazon Cognito User Pool ID
  // userPoolId: 'us-east-1_tLXhLKEeU',
  userPoolId: 'us-east-1_OrDaq8Rrx', // QA
  // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
  // userPoolWebClientId: '5frg59sqaeotm56ju4q6kb92b',
  userPoolWebClientId: '223c5vj0441ssse49evj46spno', // QA

  // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
  mandatorySignIn: false,

  // OPTIONAL - Configuration for cookie storage
  // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
  // cookieStorage: {
  // // REQUIRED - Cookie domain (only required if cookieStorage is provided)
  //     domain: '.yourdomain.com',
  // // OPTIONAL - Cookie path
  //     path: '/',
  // // OPTIONAL - Cookie expiration in days
  //     expires: 365,
  // // OPTIONAL - Cookie secure flag
  // // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
  //     secure: true
  // },

  // OPTIONAL - customized storage object
  // storage: new MyStorage(),

  // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
  authenticationFlowType: 'USER_PASSWORD_AUTH',

  // OPTIONAL - Manually set key value pairs that can be passed to Cognito Lambda Triggers
  // clientMetadata: { myCustomKey: 'myCustomValue' },
};
